'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};



/*****************
 ** WEBPACK FOOTER
 ** ../~/chart.js/src/charts/Chart.Bubble.js
 ** module id = 962
 ** module chunks = 2
 **/